import {
  Card,
  CardHeader,
  Stack,
  Button,
  Box,
  Typography,
  Chip,
  Autocomplete,
} from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import { useEffect, useState } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import React from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { DatePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import MaterialInput from "../components/MaterialInput";
import axios from "axios";
import BASEURL from "../pages/Utils/Baseurl";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import Swal from "sweetalert2";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { gql } from "@apollo/client";
import FileUpload from "../pages/Utils/FileUpload";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FiCheckCircle } from "react-icons/fi";
import { MdOutlineCancel } from "react-icons/md";
import { useUserDetails } from "../context/auth";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  OfferletterCreate,
  Deletepayslip,
  Allstaffrequestquery,
  ALL_SALARY_STRUCTURE,
  AllPayslip,
  PaySlipGetID,
  UpdatePayslip,
  GetOfferSalary,
  AllofferSalary,
  UpdateOfferLetter,
} from "./Graphql";
import { FormControl, FormHelperText } from "@mui/material";
import input from "../assest/theme/components/form/input";

const RecrruitmentTable = () => {
  const nav = useNavigate();
  // const Transition = React.forwardRef(function Transition(props, ref) {
  //   return <Slide direction="up" ref={ref} {...props} />;
  // });
  const [joiningDate, setJoiningDate] = useState(null);
  const [ctc, setCtc] = useState("");
  const [Sampledata, setSampledata] = useState([]);
  const [tabledata, settabledata] = useState([]);
  const [PayslipStatus, setPayslipStatus] = useState(false);
  const [Offerstatusbtn, setOfferstatusbtn] = useState(false);
  const { setMainId, setRowIDdata, AccessData } = useUserDetails();
 
  const [Staffdata,setStaffdata] = useState([])
  const [Onboard, setOnboard] = useState({
    todata: "",
    subject: "",
    content: "",
    ccdata: "",
    todataStatus: "unchecked",
    subjectStatus: "unchecked",
    contentStatus: "unchecked",
    ccdataStatus: "unchecked",
  });
  const [Assetdata, setAssetdata] = useState({
    assetcharge: "",
    assetchargeStatus: "unchecked",
    remaindertime: "",
    remaindertimeStatus: "",
    Content: "",
    ContentStatus: "",
    ccdata: "",
    ccdataStatus: "",
    assetName: "",
    assetNameStatus: "",
  });
  const [fileName, setFileName] = useState("");

  const [Payslip, setPayslip] = useState(null);

  const [Offerletter, setOfferletter] = useState({
    Ctc: "",
    salarystructure: "",
    joiningdate: "",
    basicPercentage: "",
    CtcStatus: "unchecked",
    salarystructureStatus: "unchecked",
    joiningdateStatus: "unchecked",
    basicPercentageStatus: "unchecked",
  });
  const department = {
    value: "",
  };

  useEffect(() => {
    // fetchData();
    onDepartmentSubmit();
    OnStaffRequest();
    Allsalarystructure();
  }, []);

  const [filterdep, setfilterdep] = useState({value:'All',label:'All'});
  const [statusdata, setstatusdata] = useState({value:'All',label:'All'});
  const [alljobid, setalljobid] = useState([]);
  const [alltabledata, setalltabledata] = useState([]);
  const [sampledata, setsampledata] = useState([]);
  const [Alldetails,setAlldetails] = useState([])
  const [departmentdata, setdepartmentdata] = useState([]);
  const jobstatus = [
    { value: "All", label: "All" },
    { value: "Open", label: "Open" },
    { value: "Closed", label: "Closed" },
    { value: "Hold", label: "Hold" },
  ];
  const handleclick = () => {
    nav("/onboarddashboard/sourceprofile");
  };
  const [Department, SetDepartment] = useState({ value: "" });
  const [payslipvalue, setpayslipvalue] = useState("");
  const [Status, setStatus] = useState({ value: "" });

  const [jobid, setjobid] = useState({ value: "All",label:'All' });

  const [Changevalue, setChangevalue] = useState({
    Changevalue: "Payslip",
    ChangevalueStatus: "unchecked",
  });

  
  const handlevaluedata = (selectedOption) => {
    let val = selectedOption?.value;
    setpayslipvalue(selectedOption);
  };


  const onDepartmentSubmit = async () => {
    const query = `query {
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allDepartment;
      setdepartmentdata(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const [SalaryStructure, setSalaryStructure] = useState([]);

  const Allsalarystructure = async () => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: ALL_SALARY_STRUCTURE,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      let result = response.data.data.salaryStructures;

      setSalaryStructure(result);
    } catch (error) {}
  };

  const OnStaffRequest = async () => {
    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: Allstaffrequestquery,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.allStaffRequests;
      // setsampledata(result);
      setStaffdata(result)
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };
  useEffect(() => {
    if (filterdep && statusdata) {
      Filterfunction();
    }
  }, [filterdep, statusdata]);

  const Filterfunction = () => {

    let filterdata = sampledata.filter(
      (val) => val.teamName === filterdep && val.jobStatus === statusdata
    );

    let jobiddata = filterdata.map((val) => {
      return {
        value: val.jobid,
        label: val.jobid,
      };
    });

    // setalljobid(jobiddata);
  };

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const changestatus = [
    { value: "Payslip", label: "Payslip" },
    { value: "Issue Offer Letter", label: "Issue Offer Letter " },
    { value: "On Boarding Mail", label: "On Boarding Mail " },
    { value: "Asset Request", label: "Asset Request " },
  ];
  const payslipoption = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  useEffect(() => {
    onDepartmentdata();
    fetchSourceScreen();
    onEmployeeeSubmit();
    Fetchstaffrequest();
    Allrequirement();
    // setChangevalue({
    //   Changevalue : {value:'Payslip',label:'Payslip'}
    // })
  }, []);
  // useEffect(()=>{
  //   fetchData();

  // },[Sampledata])

  const [departmentnames, setdepartmentnames] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [SelectAssertCC, setSelectAssertCC] = useState([]);
  const onDepartmentdata = async () => {
    const query = `query {
          allDepartment {
              id
              departmentName
              departmentCode
          }
      }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allDepartment;

      setdepartmentnames(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const [Paysliprowid, setPaysliprowid] = useState("");

  const GetPayslip = async (id) => {

    let filterdata = allrequirement.filter(
      (val) => val.sourcingScreening.id == id
    );

    let data = filterdata[0]?.id;
    setPaysliprowid(data);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: PaySlipGetID,
          variables: { id: data },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      

      const [response2] = await Promise.all([
        axios.post(
          BASEURL,
          { query: AllofferSalary },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      let finalresult = response.data.data?.recruitmentProcessById;
      let resultsalary = response2.data.data?.allOfferSalaries;
       setAlldetails(finalresult)
       setTimeout(() => {
        let finaldata = resultsalary?.filter(
          (val) => val.recruitmentProcess?.id == finalresult?.id
        );

        let iddata = finaldata[0]?.id;

        GetintidOffer(iddata);
      }, 1000);

      let payslipname = finalresult?.payslipFile;
      let paydata = payslipname.split("/").pop();

      if (finalresult?.payslipFile !== "Nil") {
        setpayslipvalue({value:'Yes',label:'Yes'})
        setPayslipStatus(true);
        setFileName(paydata);
        setChangevalue({
          Changevalue: "Payslip",
        });
        setOnboard("");
        setAssetdata("");
        setOfferletter("");
      } else if(finalresult?.payslipFile == "Nil") {
        setpayslipvalue({value:'No',label:'No'})
        setPayslipStatus(true);
        setChangevalue({
          Changevalue: "Payslip",
        });
        setOnboard("");
        setAssetdata("");
        setOfferletter("");
       
      }else{
        setPayslipStatus(false);
      }
    } catch (error) {
      setPayslipStatus(false);
      setOfferstatusbtn(false);
      setFileName("");
      setChangevalue({
        Changevalue: "Payslip",
      });
      setPayslip("");
      setOnboard("");
      setAssetdata("");
      setOfferletter("");
    }
  };

  const [UpdateSalary, setUpdateSalary] = useState([]);

  const formatIndianNumber1 = (num) => {
    if (!num) return ""; // Handle empty values gracefully
  
    let x = num.toString().replace(/,/g, ""); // Ensure it's a string and remove existing commas
    let lastThree = x.slice(-3);
    let otherNumbers = x.slice(0, -3);
  
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };

  const GetintidOffer = async (id) => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: GetOfferSalary,
          variables: { id: id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data?.offerSalary;


      setUpdateSalary(result);
      let salaryId = result?.salaryStructure?.id;

      setOfferstatusbtn(true);

      setTimeout(() => {
        let filtersalary = SalaryStructure?.filter(
          (val) => val?.id == salaryId
        );

        setOfferletter({
          ...Offerletter,
          Ctc: formatIndianNumber1(result?.ctc),
          joiningdate: result?.date,
          basicPercentage: result?.basicPercentage,
          salarystructure: {
            value: filtersalary[0]?.id,
            label: filtersalary[0]?.structureName,
          },
        });
      }, 1000);
    } catch (error) {
      setOfferstatusbtn(false);
    }
  };

  const [Allstaffrequest, setAllstaffrequest] = useState([]);
  const [AllSource, setAllSource] = useState([]);
  const [technicalFeedback, settechnicalFeedback] = useState([]);
  const [Maindata, setMaindata] = useState([]);

  const formatIndianNumber = (num) => {
    let x = num.replace(/,/g, ""); // Remove existing commas
    let lastThree = x.slice(-3);
    let otherNumbers = x.slice(0, -3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };
  const handlepostiondetails222 = (event) => {
    let value = event.target.value.replace(/,/g, ""); // Remove existing commas

    if (value === "") {
      // If input is cleared, reset the status and value
      setOfferletter((prevState) => ({
        ...prevState,
        Ctc: "",
        CtcStatus: "unchecked",
        
      }));
    } else if (/^\d{0,7}$/.test(value)) {
      // Allow only numbers up to 7 digits
      let formattedValue = formatIndianNumber(value);

      setOfferletter((prevState) => ({
        ...prevState,
        Ctc: formattedValue,
        CtcStatus: value.length >= 5 ? "success" : "error",
      }));
    }
  };

  const Fetchstaffrequest = async () => {
    const query2 = `query {
      allSourcingScreenings {
        id
        jobid
        candidateName
        screeningStatus
        source
        mobileNumber
        emailid
        totalExperience
        relevantExperience
        currentCtc
        expectedCtc
        leadTime
        yearOfPassing
        currentEmployer
        location
        comments
        interviewAvailability
        interviewer
        cvFile
      }
    }`;

    const query3 = `query {
      allTechnicalFeedback {
        id
        comments
        hiringStatus
        professionalism
        technicalSkills
        communication
        sourcingScreening {
          id
          candidateName
        }
      }
    }`;

    try {
      const [response1, response2, response3] = await Promise.all([
        axios.post(
          BASEURL,
          { query: Allstaffrequestquery }, // Fixed the incorrect structure
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          { query: query2 },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          { query: query3 },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      const allStaffRequests = response1.data.data.allStaffRequests;
      const allSourcingScreenings = response2.data.data.allSourcingScreenings;
      const allTechnicalFeedback = response3.data.data.allTechnicalFeedback; // Fixed accessing response3 data
      setAllstaffrequest(allStaffRequests);
      setAllSource(allSourcingScreenings);
      settechnicalFeedback(allTechnicalFeedback);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleview = (id, rowid) => {

    let filterdata = Sampledata.filter((val) => val.id == rowid);
    setRowIDdata(filterdata);
    setMainId(id);
    nav("/Offer");
  };

  const SalaryStructureListTable = {
    columns: [
      {
        field: "jobid",
        headerName: "Job ID",
        width: 130,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "candidateName",
        headerName: "Name",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "position",
        headerName: "Position",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "hirringstatus",
        headerName: "Status",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "payslip",
        headerName: "Payslip Verification",
        width: 150,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "offerLetter",
        headerName: "Offer Letter",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "OnBoarding",
        headerName: "OnBoarding",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "AssetRequest",
        headerName: "Asset Request",
        width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      ...(AccessData &&
      Array.isArray(AccessData) &&
      AccessData.some(
        (item) => item.component === "AddRequirement" && item.can_access
      )
        ? [
            {
              field: "map",
              headerName: "Change Status",
              width: 130,
              editable: false,
              disableColumnMenu: true,
              sortable: true,
            },
          ]
        : []),
    ],
    rows: tabledata?.slice().reverse().map((leave) => ({
      id: leave.id,
      jobid: leave.jobid,
      candidateName: leave.candidateName,
      position: leave.position,
      hirringstatus: leave.hirringstatus,
      map: (
        <Button
          onClick={(e) => {
            e.stopPropagation(); // Prevent onRowClick from triggering
            setOpen(true); // Open modal or perform your action
            Fetchaalldata(leave.id);
            GetPayslip(leave.id);
            setpayslipvalue("");
          }}
          sx={{
            border: "1px solid #3F51B5d4",
            color: "#3F51B5d4",
            backgroundColor: "white",
            padding: "8px 16px",
            borderRadius: "8px",
            fontWeight: "bold",
            textTransform: "uppercase",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#3F51B5d4",
              color: "#ffffff",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            },
            "&:active": {
              backgroundColor: "#303F9F",
              borderColor: "#303F9F",
            },
          }}
        >
          Change
        </Button>
      ),
      payslip:
        leave.Payslip != null ? (
          <FaCloudDownloadAlt
            onClick={(e) => {
              e.stopPropagation(); // Prevent the event from propagating
              downloadCV(leave.Payslip); // Pass the file name or URL
            }}
            style={{ fontSize: "25px", cursor: "pointer" ,  marginLeft: "30px",
              marginTop: "13px", }}
          />
        ) :  (
          <MdOutlineCancel
            style={{ fontSize: "25px", cursor: "pointer", color: "#FF6666",  marginLeft: "30px",
              marginTop: "13px", }}
          />
        ),
      OnBoarding: leave.onBording ? (
        <FiCheckCircle
          style={{ fontSize: "25px", cursor: "pointer", color: "#2ecc71",  marginLeft: "30px",
            marginTop: "13px", }}
        />
      ) : (
        // <span style={{ color: "red", fontWeight: "bold" }}>PENDING</span>
        <MdOutlineCancel
          style={{ fontSize: "25px", cursor: "pointer", color: "#FF6666",  marginLeft: "30px",
            marginTop: "13px", }}
        />
      ),
      AssetRequest: leave.assertRequest ? (
        <FiCheckCircle
          style={{ fontSize: "25px", cursor: "pointer", color: "#2ecc71",  marginLeft: "30px",
            marginTop: "13px", }}
        />
      ) : (
        // <span style={{ color: "red", fontWeight: "bold" }}>PENDING</span>
        <MdOutlineCancel
          style={{ fontSize: "25px", cursor: "pointer", color: "#FF6666",  marginLeft: "30px",
            marginTop: "13px", }}
        />
      ),
      offerLetter: leave.offerLetter ? (
        // <FiCheckCircle
        //   style={{ fontSize: "25px", cursor: "pointer", color: "#2ecc71" }}
        // />\
        <span
          style={{ color: "#3F51B5d4", fontWeight: "bold", cursor: "pointer",  marginLeft: "30px",
            marginTop: "13px", }}
          onClick={() => handleview(leave.RowId, leave.id)}
        >
          View
        </span>
      ) : (
        // <span style={{ color: "red", fontWeight: "bold" }}>PENDING</span>
        <MdOutlineCancel
          style={{ fontSize: "25px", cursor: "pointer", color: "#FF6666",  marginLeft: "30px",
            marginTop: "13px", }}
        />
      ),
    })),
  };


  const downloadCV = async (cvFile) => {

    let CvName = cvFile.split("/").pop();


    const downloadButton = document.getElementById("downloadButton");
    if (downloadButton) downloadButton.style.display = "none";

    try {
      const fileUrl = `${FileUpload}payslip_files/${CvName}`;

      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const fileUrlObject = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileUrlObject;
      link.download = CvName;
      link.click();

      URL.revokeObjectURL(fileUrlObject);
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      if (downloadButton) downloadButton.style.display = "inline-block";
    }
  };

 
  

  const Fetchaalldata = (id) => {

    let Maindata = tabledata.filter((val) => val.id == id);

    let staff = Allstaffrequest.filter(
      (val) => val.jobid == Maindata[0]?.jobid
    );
    let technical = technicalFeedback.filter(
      (val) => val.sourcingScreening?.id == id
    );

    const staffid = staff.flatMap((data) =>
      technical.map((val) => ({
        staffid: data.id,
        technical: val.id,
        allsource: id,
      }))
    );

    

    setMaindata(staffid);
  };

  const [Allemail, setAllemail] = useState([]);

  const [allrequirement, setallrequirement] = useState([]);

  const Allrequirement = async () => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: AllPayslip,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data?.allRecruitmentProcesses;

      

      setallrequirement(result);
    } catch (error) {
    }
  };

  const onEmployeeeSubmit = async () => {
    const query = `query{
    allUsersDetail{
    id
    lastLogin
    username
    firstName
    lastName
    isActive
    dateJoined
    email
    salutation
    dateOfBirth
    contactNumber
    emergencyContact
    gender
    employeeType
    lastUpdate
    department
    designation
    empid
    teamleader 
    grade
    }}`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.allUsersDetail;

      let alldata = result.map((data) => {
        return {
          value: data.email,
          label: data.email,
        };
      });

      setAllemail(alldata);
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  const handlechange = (event, selectEvent) => {
    let sourceState = { ...Changevalue };

    if (!event?.target && selectEvent) {
      if (selectEvent.name === "Changevalue") {
        const lengthRegex = /^[A-Za-z0-9\s]+$/;
        const trimmedLabel = event?.label?.trim(); // Trim the space

        const isValidLabel = lengthRegex.test(trimmedLabel);

        // Set status based on the validity of the selected label
        sourceState[`${selectEvent.name}Status`] = isValidLabel
          ? "success"
          : selectEvent.value
          ? "error"
          : "unchecked";

        // Ensure Changevalue is updated with the trimmed label
        sourceState[selectEvent.name] = trimmedLabel;
      }
    }

    setChangevalue(sourceState);
  };


  const departmentName = [
    {
      id: "HR",
      departmentName: "hr",
    },

    {
      id: "Dev",
      departmentName: "dev",
    },

    {
      id: "DEV",
      departmentName: "dev",
    },
  ];

  const [Departmentnames, setnames] = useState({
    depatmentdate: departmentName,
  });

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
  };

  const handleSubmit = () => {
  };

  const fetchSourceScreen = async () => {
    const query = `
      query {
        allSourcingScreenings {
          id
          jobid
          candidateName
          screeningStatus
          source
          mobileNumber
          emailid
          totalExperience
          department
          position
          relevantExperience
          currentCtc
          expectedCtc
          leadTime
          yearOfPassing
          currentEmployer
          location
          comments
          position
          interviewAvailability
          interviewer
          cvFile
        }
      }
    `;

    const query1 = `
      query GetAllTechnicalFeedback {
        allTechnicalFeedback {
          id
          comments
          hiringStatus
          professionalism
          technicalSkills
          levelOfInterest
          learningAbility
          confidence
          attitude
          communication
          sourcingScreening {
            id
            candidateName
          }
        }
      }
    `;

    try {
      const [response1, response2, response3] = await Promise.all([
        axios.post(
          BASEURL,
          { query },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          { query: query1 },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          { query: AllPayslip },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      const sourcingScreenings =
        response1.data?.data?.allSourcingScreenings || [];
      const technicalFeedback =
        response2.data?.data?.allTechnicalFeedback || [];
      const allpayslip = response3.data?.data?.allRecruitmentProcesses || [];

      setTimeout(() => {
        const feedbackIds = new Set(
          technicalFeedback.map((feedback) => feedback.sourcingScreening?.id)
        );

        const filteredData = sourcingScreenings.filter((screening) =>
          feedbackIds.has(screening.id)
        );
        const requirementdata = allpayslip.filter((screening) =>
          feedbackIds.has(screening.sourcingScreening.id)
        );

        const allfilterdata = filteredData.map((dat) => {
          const matchingPayslip = requirementdata.find(
            (val) => dat?.id === val.sourcingScreening?.id
          );

          return {
            ...dat,
            Payslip: matchingPayslip?.payslipFile !=='Nil' ? matchingPayslip?.payslipFile : null,
            RowId: matchingPayslip?.id,
            onBording: matchingPayslip ? matchingPayslip.onBording : null,
            assertRequest: matchingPayslip
              ? matchingPayslip.assertRequest
              : null,
            offerLetter: matchingPayslip?.offerLetter
              ? matchingPayslip?.offerLetter
              : null,
          };
        });

        const resultdata = allfilterdata.map((val) => {
          const match = technicalFeedback.find(
            (th) => val.id == th.sourcingScreening?.id
          );

          return {
            ...val,
            hirringstatus: match.hiringStatus,
          };
        });


        let filtervalue = resultdata.filter(
          (res) =>
            res.hirringstatus !== "Rejected" && res.hirringstatus !== "On hold"
        );


        let Jobdata = Array.from(
          new Set(filtervalue.map(val => val.jobid))
        ).map(jobid => ({ jobid }));
        

        setalljobid(Jobdata)

        settabledata(filtervalue);
        setSampledata(filtervalue);
      }, 500);

      // setSampledata(sourcingScreenings);
      setalltabledata(sourcingScreenings);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const handleOnboard = (event, selectEvent) => {
    let sourceState = { ...Onboard };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "jobid") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "screeningStatus") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "source") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "todata":
          {
            const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (emailRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "subject":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "ccdata":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "content":
          {
            const alphaNumberLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,1000}$"
            );
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setOnboard(sourceState);
  };
  const handleAsstet = (event, selectEvent) => {
    let sourceState = { ...Assetdata };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "jobid") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "screeningStatus") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "source") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "assetName":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "assetcharge":
          {
            const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (emailRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "remaindertime":
          if (event.target.value?.trim()) {
            sourceState[event.target.name + "Status"] = "success";
          } else {
            sourceState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;

        case "Content":
          {
            const alphaNumberLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,1000}$"
            );
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setAssetdata(sourceState);
  };

  const handleOnboarding = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to send the mail?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        Onboarding();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const Onboarding = async () => {
    const query1 = `
      mutation SendOnboardingMail($input: SendOnboardingMailInput!) {
        SendOnboardingMail(input: $input) {
          success
          message
        }
      }
    `;

    const query2 = `
      mutation UpdateRecruitmentProcess($id: ID!, $input: RecruitmentProcessInput!) {
        updateRecruitmentProcess(id: $id, input: $input) {
          recruitmentProcess {
            id
            screening
            technicalInterview
            interviewStatus
            offerLetter
            onBording
            assertRequest
            documentVerification
            appointmentLetter
            nda
            hrInduction
            technicalInduction
            teamIntro
            assestHandover
            hrmsAccess
            handoverToManager
          }
          success
          message
        }
      }
    `;

    let Emaildata = selectedOptions.map((data) => data.label);

    let filterdata = allrequirement.filter(
      (val) => val.sourcingScreening.id === Maindata[0]?.allsource
    );

    let Input_data = {
      toEmail: Onboard.todata,
      content: Onboard.content,
      ccEmails: Emaildata,
      subject: "Welcome to the Team!",
    };

    const variables = {
      id: filterdata[0]?.id, // Ensure filterdata has a valid id before calling API
      input: {
        onBording: true,
      },
    };

    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: query1,
            variables: { input: Input_data },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);


      let result = response1.data.data.SendOnboardingMail;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Mail Sent Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        fetchSourceScreen();
        setChangevalue({
          ...Changevalue,
          Changevalue: "Asset Request",
        });
      }
    } catch (error) {
    }
  };

  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");

  const handleAddChip = () => {
    if (inputValue.trim() === "") return;
    const newOption = {
      label: inputValue.trim(),
      value: inputValue.trim().toLowerCase().replace(/\s+/g, "_"),
    };

    setSelectedOptions((prev) => [...prev, newOption]);

    setInputValue("");
  };
  const handleAddChipAssert = () => {
    if (inputValue1.trim() === "") return;
    const newOption = {
      label: inputValue1.trim(),
      value: inputValue1.trim().toLowerCase().replace(/\s+/g, "_"),
    };

    setSelectAssertCC((prev) => [...prev, newOption]);

    setInputValue1("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " " || event.key === ",") {
      event.preventDefault();
      handleAddChip();
    }
  };
  const handleKeyDown1 = (event) => {
    if (event.key === "Enter" || event.key === " " || event.key === ",") {
      event.preventDefault();
      handleAddChipAssert();
    }
  };

  const handleChange = (event, newValue) => {
    setOnboard({
      ...Onboard,
      ccdata: newValue,
    });
    setSelectedOptions(newValue);
  };
  const handleChange1 = (event, newValue) => {
    setAssetdata({
      ...Assetdata,
      ccdata: newValue,
    });
    setSelectAssertCC(newValue);
  };

  const handledepartment = (selectedOption) => {
    let value = selectedOption.label;
    setfilterdep(selectedOption)

     if(value =='All'){
      let filterdata = Sampledata.filter((val)=> val.jobStatus == statusdata.label)
      settabledata(Sampledata)
    }else if (value !=='All'){
      if(statusdata.label == 'All'){
        
        let filterdata = Sampledata.filter((val)=>  val.department == value)
        
        settabledata(filterdata)
      }else{
        let filterdata = Sampledata.filter((val)=> val.jobStatus == statusdata.label && val.department == value)

        
        settabledata(filterdata)
      }
      
    
    }
  };

  const handlestatus = (selectedOption) => {
    let data = selectedOption?.value;
    setstatusdata(selectedOption);

    if (filterdep.label === "All") {
      if (data === "All") {
        settabledata(Sampledata);
      } else {
        let filterdata = Staffdata.filter((val) => val.jobStatus === data);
  
        let valdata = Sampledata.filter((val) =>
          filterdata.some((dat) => val.jobid === dat.jobid)
        );
  
  
        let Jobdata = Array.from(new Set(valdata.map((val) => val.jobid))).map(
          (jobid) => ({ jobid })
        );

        
  
        setalljobid(Jobdata);
        settabledata(valdata);
      }
    } else {
      if (data === "All") {
        let filterdata = Sampledata.filter(
          (val) => val.department === filterdep.label
        );
        settabledata(filterdata);
      } else {
        let filterdata = Staffdata.filter(
          (val) => val.jobStatus === data && val.teamName === filterdep.label
        );
  
        let valdata = Sampledata.filter((val) =>
          filterdata.some((dat) => val.jobid === dat.jobid)
        );
  
  
        let Jobdata = Array.from(new Set(valdata.map((val) => val.jobid))).map(
          (jobid) => ({ jobid })
        );
  
        setalljobid(Jobdata);
        settabledata(valdata);
      }
    }
  };

  

  const handlejobid = (selectedOption) =>{
    let data = selectedOption.value
    setjobid(selectedOption)

    if(filterdep.label == 'All' && statusdata.label=='All'){
       if(data == 'All'){
         settabledata(Sampledata)
       }else {
         let filterdata = Sampledata.filter((val)=>val.jobid === data)
    
         settabledata(filterdata)
  
       }
    }else if(statusdata.label !=='All'){
     if(data == 'All'){
       let filterdata = Staffdata.filter((val) => val.jobStatus == statusdata.label);
       
       let valdata = filterdata
       .filter(dat => dat.jobStatus === statusdata.label) 
       .flatMap(dat => Sampledata.filter(val => val.jobid === dat.jobid)); 
        settabledata(valdata)
     }else{
       let filterdata = Sampledata.filter((val)=>val.jobid === data)
    
       settabledata(filterdata)
     }
  
    }

   //  let filterdata = alltabledata.filter((val)=>val.jobid === data)
    
   //  settabledata(filterdata)


};

  const handleSalary = (event, selectEvent) => {
    let sourceState = { ...Offerletter };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "salarystructure") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "Ctc":
          {
            const alphaNumberLengthRegex = new RegExp("^[0-9]{1,25}$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "basicPercentage":
          {
            const lengthRegex = /^\d*\.?\d+$/;
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (lengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "joiningdate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (dateLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setOfferletter(sourceState);
  };

  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });

  const handleFileUpload = (files) => {
    if (files.length > 0) {
      const file = files[0];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
  
      if (file.size > maxSize) {
        alert("File size exceeds 2MB. Please upload a smaller file.");
        return; // Stop execution if file is too large
      }
  
      setFileName(file.name);
  
      if (
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        setPayslip(file); // Update state with the uploaded file
      } else {
        alert(
          "Unsupported file format. Please upload a PDF, DOC, or DOCX file."
        );
      }
    }
  };
  

  const handlePay = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${payslipvalue?.value == 'Yes' ? 'Upload' : 'submit'} the ${payslipvalue?.value == 'Yes' ? 'Payslip' : 'details'}?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handlePayslip();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handlePayslip = async () => {
    const query = gql`
      mutation CreateRecruitmentProcess($input: RecruitmentProcessInput!) {
        createRecruitmentProcess(input: $input) {
          recruitmentProcess {
            id
            screening
            technicalInterview
            interviewStatus
            offerLetter
            onBording
            assertRequest
            documentVerification
            appointmentLetter
            nda
            hrInduction
            technicalInduction
            teamIntro
            assestHandover
            hrmsAccess
            handoverToManager
          }
          success
          message
        }
      }
    `;

    try {
      const variables = {
        input: {
          staffRequestId: Maindata[0]?.staffid,
          sourcingScreeningId: Maindata[0]?.allsource,
          technicalFeedbackId: Maindata[0]?.technical,
          payslipFile: payslipvalue?.value == 'Yes' ? Payslip : 'Nil',
          screening: false,
          technicalInterview: false,
          interviewStatus: false,
          offerLetter: false,
          onBording: false,
          assertRequest: false,
          documentVerification: false,
          appointmentLetter: false,
          nda: false,
          hrInduction: false,
          technicalInduction: false,
          teamIntro: false,
          assestHandover: false,
          hrmsAccess: false,
          handoverToManager: false,
        },
      };

      const response = await client.mutate({
        mutation: query,
        variables: variables,
      });

      const finalData =
        response.data.createRecruitmentProcess;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (finalData?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Payslip Uploaded Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        // navigate("/sourcing");
        fetchSourceScreen();
        Fetchstaffrequest();
        Allrequirement();
        setOpen(false)
       
       
        // setTimeout(() => {
        //   setOpen(true)
        //   setChangevalue({
        //     Changevalue: "Issue Offer Letter",
        //   });
        // }, 2000);
    
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  const handleupdatepayslip = async () => {
    const query = `
      mutation UpdateRecruitmentProcess($id: ID!, $input: RecruitmentProcessInput!) {
        updateRecruitmentProcess(id: $id, input: $input) {
          recruitmentProcess {
            id
            screening
            technicalInterview
            interviewStatus
            offerLetter
            onBording
            assertRequest
            documentVerification
            appointmentLetter
            nda
            hrInduction
            technicalInduction
            teamIntro
            assestHandover
            hrmsAccess
            handoverToManager
          }
          success
          message
        }
      }
    `; 



  
    try {
      const variables = {
        id: Paysliprowid,
        input: {
          payslipFile: payslipvalue?.value === "Yes" ? Payslip : "Nil",
          screening: Alldetails?.screening ?? false,
          technicalInterview: Alldetails?.technicalInterview ?? false,
          interviewStatus: Alldetails?.interviewStatus ?? false,
          offerLetter: Alldetails?.offerLetter ?? false,
          onBording: Alldetails?.onBording ?? false,
          assertRequest: Alldetails?.assertRequest ?? false,
          documentVerification: Alldetails?.documentVerification ?? false,
          appointmentLetter: Alldetails?.appointmentLetter ?? false,
          nda: Alldetails?.nda ?? false,
          hrInduction: Alldetails?.hrInduction ?? false,
          technicalInduction:  Alldetails?.technicalInduction ?? false,
          teamIntro:  Alldetails?.teamIntro ?? false,
          assestHandover: Alldetails?.assestHandover ?? false,
          hrmsAccess: Alldetails?.hrmsAccess ?? false,
          handoverToManager: Alldetails?.handoverToManager ?? false,
        },
      };
  
  
      if (variables.input.payslipFile !== "Nil") {
        try {
          const response = await client.mutate({
            mutation: gql(query), // ✅ Use gql only with Apollo Client
            variables,
          });
  

       let result = response.data?.updateRecruitmentProcess 

        if(result?.success){
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Payslip Updated Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          // navigate("/sourcing");
          fetchSourceScreen();
           setOpen(false)
        }

        } catch (error) {
          console.error("Apollo Mutation Error:", error);
        }
      } else {
        try {
          const response = await axios.post(
            BASEURL,
            {
              query, // ✅ Pass string query
              variables,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          let result = response.data.data?.updateRecruitmentProcess 

          if(result.success){
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Payslip Updated Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
            // navigate("/sourcing");
            fetchSourceScreen();
            setOpen(false)
          }
        } catch (error) {
          console.error("Axios Mutation Error:", error);
        }
      }
    } catch (error) {
      console.error("Mutation Error:", error);
    }
  };
  

  const handleoffer = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleofferletter();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleofferletter = async () => {
    let filterdata = allrequirement.filter(
      (val) => val.sourcingScreening.id == Maindata[0]?.allsource
    );

    const variables = {
      recruitmentProcessId: filterdata[0]?.id ? filterdata[0]?.id : "",
      salaryStructureId: Offerletter.salarystructure?.value,
      ctc: Offerletter.Ctc.replace(/,/g, ""),
      basicPercentage: Offerletter.basicPercentage,
      date: Offerletter.joiningdate,
    };
  
    

    if (variables.recruitmentProcessId == "") {
      Swal.fire({
        icon: "warning",
        title: "Upload the PaySlip First!",
      });
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setTimeout(() => {
        setChangevalue({
          Changevalue: "Payslip",
        });
      }, 2000);
      setOfferletter("");
    }

    const variables1 = {
      id: filterdata[0]?.id,
      input: {
        offerLetter: true,
      },
    };

    try {
      // const response = await axios.post(BASEURL, {
      //   query: OfferletterCreate,
      //   variables: variables,
      // });


      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: OfferletterCreate,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables1,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      let result1 = response1.data.data.onboardCalculateEmployeeSalary;
      let result2 =
        response2.data.data.updateRecruitmentProcess.recruitmentProcess;
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      if (result1 !== '') {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Offer Letter Created Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        fetchSourceScreen();
        setChangevalue({
          ...Changevalue,
          Changevalue: "On Boarding Mail",
        });
      }
    } catch (error) {
    }
  };

  const checkAllAssertFields = () => {
    let allowSubmit = false;
    if (
      // staffrequest.jobidStatus === "success" &&
      Assetdata.assetNameStatus === "success" &&
      Assetdata.assetchargeStatus === "success" &&
      Assetdata.remaindertimeStatus === "success" &&
      Assetdata.ContentStatus === "success" &&
      SelectAssertCC != ""
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const checkAllOnboardFields = () => {
    let allowSubmit = false;
    if (
      Onboard.todataStatus === "success" &&
      Onboard.contentStatus === "success" &&
      selectedOptions != ""
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const checkAllOfferFields = () => {
    let allowSubmit = false;
    if (
      Offerletter.CtcStatus === "success" &&
      Offerletter.salarystructureStatus === "success" &&
      Offerletter.basicPercentageStatus === "success" &&
      Offerletter.joiningdateStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handledete = async () => {
    try {
      const response = await axios.post(BASEURL, {
        query: Deletepayslip,
        variables: {
          id: "45",
        },
      });

    } catch (error) {
    }
  };


  const handleassertmail = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleAssest();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleAssest = async () => {
    const query = `mutation SendAssetRequestMail($assetRequest: AssetRequestInput!) {
  SendAssetRequestMail(assetRequest: $assetRequest) {
    success
    message
  }
}`;

    let Emaildata = SelectAssertCC.map((data) => data.label);

    let filterdata = allrequirement.filter(
      (val) => val.sourcingScreening.id === Maindata[0]?.allsource
    );

    let Input_data = {
      assetName: Assetdata.assetName,
      requestId: "REQ1234523",
      reminderTime:
        new Date().toISOString().split("T")[0] +
        "T" +
        Assetdata.remaindertime +
        ":00Z", // Convert to DateTime format

      reminderContent: Assetdata.Content,
      toEmail: Assetdata.assetcharge,
      ccEmails: Emaildata,
    };

    const variables = {
      id: filterdata[0]?.id,
      input: {
        assertRequest: true,
      },
    };

    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: query,
            variables: { assetRequest: Input_data },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdatePayslip,
            variables: variables,
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      let result = response1.data.data.SendAssetRequestMail;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Assert Sent Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        fetchSourceScreen();
        setChangevalue({
          ...Changevalue,
          Changevalue: "Asset Request",
        });
        setOpen(false)
      }
    } catch (error) {
    }
  };

  const checkAllPayslip = () => Boolean(Payslip || payslipvalue?.value === 'No');

  const OfferleterUpdate = async () => {
    const variables = {
      input: {
        id: UpdateSalary?.id,
        salaryStructureId: Offerletter.salarystructure?.value,
        basicPercentage: Offerletter.basicPercentage,
        ctc: Offerletter.Ctc.replace(/,/g, ""),
        date: Offerletter.joiningdate,
      },
    };


    try {
      const response = await axios.post(
        BASEURL,
        {
          query: UpdateOfferLetter, // Correctly placing the mutation inside query
          variables: variables, // Including variables correctly
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data?.updateOnboardEmployeeSalary;

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Offer Letter Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setOpen(false);
      }
    } catch (error) {
    }
  };

  

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Recruitment Details
                  </MaterialTypography>
                  {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                </Stack>
              </Stack>

              <Stack
                direction="row"
                // justifyContent="space-between"
                // alignItems="center"
                spacing={2}
              >
                <Stack marginLeft={3}>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      color="black"
                      lineHeight={3}
                    >
                      Department
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="department"
                    value={filterdep}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handledepartment}
                    options={[
                      {value:'All',label:'All'},
                      ...departmentdata.map((value) => {
                      return {
                        value: value.id,
                        label: value.departmentName,
                      };
                    })]}
                    error={false}
                    // success={true}
                    // isClearable
                  />
                </Stack>

                <Stack>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      color="black"
                      lineHeight={3}
                    >
                      Status
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="status"
                    value={statusdata}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handlestatus}
                    options={jobstatus.map((value) => {
                      return {
                        value: value.value,
                        label: value.value,
                      };
                    })}
                    error={false}
                    // success={true}
                    // isClearable
                  />
                </Stack>
                <Stack>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      color="black"
                      lineHeight={3}
                    >
                      Jobid
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="Jobid"
                    value={jobid}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handlejobid}
                    options={[
                      { value: "All", label: "All" },
                    ...alljobid?.map((value) => {
                      return {
                        value: value.jobid,
                        label: value.jobid,
                      };
                    })]}
                    error={false}
                    // success={true}
                    // isClearable
                  />
                </Stack>
                {/* <Button onClick={handledete}>Delete</Button> */}
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={SalaryStructureListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={""}
          loading={""}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No recruitment details found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any recruitment details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
      <MaterialBox>
        <Dialog
          open={open}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-paper": {
              width: "600px",
              borderRadius: "12px",
              padding: "24px",
            },
          }}
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              color: "#3F51B5",
              fontWeight: 600,
              fontSize: "1.6rem",
            }}
          >
            Change Status
          </DialogTitle>

          <DialogContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                padding: "12px",
                borderRadius: "8px",
                backgroundColor: "#F5F5F5",
              }}
            >
              <Typography
                sx={{
                  color: "#3F51B5",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                }}
              >
                Current Status
              </Typography>
              <Typography
                sx={{ color: "#757575", fontSize: "1.1rem", fontWeight: 400 }}
              >
                {Changevalue.Changevalue}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography
                sx={{
                  marginRight: "12px",
                  fontWeight: 500,
                  fontSize: "1.1rem",
                }}
              >
                Change{" "}
              </Typography>
              <MaterialSelect
                name="Changevalue"
                value={changestatus.find(
                  (option) => option.value === Changevalue.Changevalue
                )}
                onChange={handlechange}
                options={changestatus}
                error={false}
                sx={{
                  width: "100%",
                  backgroundColor: "#FFF",
                  borderRadius: "8px",
                  padding: "10px",
                }}
              />
            </Box>

            {/* Conditional Sections Based on Selected Changevalue */}
            {Changevalue.Changevalue === "Payslip" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Typography
                    sx={{
                      marginRight: "12px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    PaySlip <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialSelect
                    name="Changevalue"
                    value={payslipvalue}
                    onChange={handlevaluedata}
                    options={payslipoption}
                    error={false}
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </Box>

                {payslipvalue?.value == "Yes" && (
                  <Box>
                    <input
                      type="file"
                      id="fileUpload"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileUpload(e.target.files)}
                    />

                    {/* Custom Upload Button */}
                    <label htmlFor="fileUpload">
                      <Button
                        variant="contained"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                        sx={{
                          textTransform: "none",
                          fontSize: "1rem",
                          padding: "12px 24px",
                          borderRadius: "12px",
                          backgroundColor: "#4CAF50",
                          color: "#FFF",
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                          "&:hover": { backgroundColor: "#388E3C" },
                        }}
                      >
                        Upload PaySlip
                      </Button>
                    </label>

                    {/* Display Uploaded File Name */}
                    {fileName && (
                      <Typography
                        sx={{
                          marginTop: "12px",
                          fontSize: "0.95rem",
                          color: "#333",
                          fontStyle: "italic",
                          backgroundColor: "#f5f5f5",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          display: "inline-block",
                        }}
                      >
                        📄 {fileName}
                      </Typography>
                    )}
                  </Box>
                )}

                <DialogActions sx={{ justifyContent: "center" }}>
                  <MaterialButton
                    onClick={() => setOpen(false)}
                    variant="gradient"
                    color="dark"
                  >
                    Cancel
                  </MaterialButton>
                  {PayslipStatus ? (
                    <MaterialButton
                      onClick={handleupdatepayslip}
                      variant="gradient"
                      color="dark"
                    >
                      Update
                    </MaterialButton>
                  ) : (
                    <MaterialButton
                      disabled={!checkAllPayslip()}
                      onClick={handlePay}
                      variant="gradient"
                      color="dark"
                    >
                      Submit
                    </MaterialButton>
                  )}
                </DialogActions>
              </>
            )}

            {Changevalue.Changevalue === "Issue Offer Letter" && (
              <>
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    CTC PA <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    value={Offerletter.Ctc}
                    name="Ctc"
                    onChange={handlepostiondetails222}
                    error={Offerletter.CtcStatus === "error"}
                    success={Offerletter.CtcStatus === "success"}
                    variant="outlined"
                    size="small"
                    // placeholder="Enter CTC PA"
                    sx={{
                      fontSize: "1rem",
                      padding: "10px",
                      borderRadius: "8px",
                      backgroundColor: "#FFF",
                    }}
                  />
                  {Offerletter.CtcStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                      Enter a valid Salary (5 to 7 digits)
                      </FormHelperText>
                    </FormControl>
                  )}
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Salary Structure <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialSelect
                    name="salarystructure"
                    value={Offerletter.salarystructure}
                    onChange={handleSalary}
                    options={SalaryStructure.map((value) => ({
                      value: value.id,
                      label: value.structureName,
                    }))}
                    error={Offerletter.salarystructureStatus === "error"}
                    success={Offerletter.salarystructureStatus === "success"}
                    isClearable
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                    isDisabled={!Offerletter.Ctc || Offerletter.Ctc.trim() === ""}                  />
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Basic Percentage <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    value={Offerletter.basicPercentage}
                    name="basicPercentage"
                    onChange={handleSalary}
                    variant="outlined"
                    size="small"
                    error={Offerletter.basicPercentageStatus === "error"}
                    success={Offerletter.basicPercentageStatus === "success"}
                    sx={{
                      fontSize: "1rem",
                      padding: "10px",
                      borderRadius: "8px",
                      backgroundColor: "#FFF",
                    }}
                  />
                  {Offerletter.basicPercentageStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Basic Percentage must contain only numbers
                      </FormHelperText>
                    </FormControl>
                  )}
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
  <Typography
    sx={{
      marginBottom: "8px",
      fontWeight: 500,
      fontSize: "1.1rem",
    }}
  >
    Joining Date <span style={{ color: "red" }}>*</span>
  </Typography>
  <MaterialInput
    type="date"
    name="joiningdate"
    value={Offerletter.joiningdate}
    onChange={handleSalary}
    error={Offerletter.joiningdateStatus === "error"}
    success={Offerletter.joiningdateStatus === "success"}
    variant="outlined"
    size="small"
    sx={{
      fontSize: "1rem",
      padding: "10px",
      borderRadius: "8px",
      backgroundColor: "#FFF",
    }}
    inputProps={{
      min: new Date().toISOString().split("T")[0], // Restrict past dates
    }}
  />
</Box>


                {/* <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "1.1rem",
                      color: "#3F51B5",
                    }}
                  >
                    Net Pay: <span style={{ color: "#000" }}>Amount</span>
                  </Typography>
                </Box> */}

                <DialogActions sx={{ justifyContent: "center" }}>
                  <MaterialButton
                    onClick={() => setOpen(false)}
                    variant="gradient"
                    color="dark"
                  >
                    Cancel
                  </MaterialButton>
                  {Offerstatusbtn ? (
                    <MaterialButton
                      onClick={OfferleterUpdate}
                      variant="gradient"
                      color="dark"
                    >
                      Update
                    </MaterialButton>
                  ) : (
                    <MaterialButton
                      onClick={handleoffer}
                      variant="gradient"
                      color="dark"
                      disabled={!checkAllOfferFields()}
                    >
                      Submit
                    </MaterialButton>
                  )}
                </DialogActions>
              </>
            )}

            {Changevalue.Changevalue === "On Boarding Mail" && (
              <>
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    From <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="Jobid"
                    value="KEELIS"
                    disabled={true}
                    error={false}
                    isClearable
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    To <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="todata"
                    value={Onboard.todata}
                    onChange={handleOnboard}
                    error={Onboard.todataStatus === "error"}
                    success={Onboard.todataStatus === "success"}
                    // isClearable
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                  {Onboard.todataStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Please enter a valid email address
                      </FormHelperText>
                    </FormControl>
                  )}
                </Box>
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    CC <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <Autocomplete
                    multiple
                    freeSolo
                    options={Allemail}
                    getOptionLabel={(option) => option.label}
                    error={Onboard.ccdataStatus === "error"}
                    success={Onboard.ccdataStatus === "success"}
                    value={selectedOptions}
                    onChange={handleChange}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) =>
                      setInputValue(newInputValue)
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select or Type"
                        // placeholder="Press Enter, Space, or Comma to add"
                        onKeyDown={handleKeyDown} // Capture key presses
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          key={option.value}
                          label={option.label}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </Box>
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Content <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="content"
                    multiline
                    rows={3.5}
                    value={Onboard.content}
                    onChange={handleOnboard}
                    error={Onboard.contentStatus === "error"}
                    success={Onboard.contentStatus === "success"}
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </Box>

                <DialogActions sx={{ justifyContent: "center" }}>
                  <MaterialButton
                    onClick={() => setOpen(false)}
                    variant="gradient"
                    color="dark"
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={handleOnboarding}
                    disabled={!checkAllOnboardFields()}
                  >
                    Submit
                  </MaterialButton>
                </DialogActions>
              </>
            )}

            {Changevalue.Changevalue === "Asset Request" && (
              <>
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Asset Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="assetName"
                    placeholder="eg.LAPTOP"
                    value={Assetdata.assetName}
                    onChange={handleAsstet}
                    error={Assetdata.assetNameStatus === "error"}
                    success={Assetdata.assetNameStatus === "success"}
                    // isClearable
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                  {Assetdata.assetNameStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        {" "}
                        Asset Name should be contain only alphabets{" "}
                      </FormHelperText>
                    </FormControl>
                  )}
                </Box>
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Asset In charge <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="assetcharge"
                    placeholder="eg.ABCD@KEELIS.COM"
                    value={Assetdata.assetcharge}
                    onChange={handleAsstet}
                    error={Assetdata.assetchargeStatus === "error"}
                    success={Assetdata.assetchargeStatus === "success"}
                    // isClearable
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    CC <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <Autocomplete
                    multiple
                    freeSolo
                    options={Allemail}
                    getOptionLabel={(option) => option.label}
                    value={SelectAssertCC}
                    onChange={handleChange1}
                    inputValue={inputValue1}
                    onInputChange={(event, newInputValue) =>
                      setInputValue1(newInputValue)
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        onKeyDown={handleKeyDown1}
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          key={option.value}
                          label={option.label}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Reminder Time <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="remaindertime"
                    type="time"
                    value={Assetdata.remaindertime}
                    onChange={handleAsstet}
                    error={Assetdata.remaindertimeStatus === "error"}
                    success={Assetdata.remaindertimeStatus === "success"}
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </Box>

                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      marginBottom: "8px",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                    }}
                  >
                    Reminder Content <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <MaterialInput
                    name="Content"
                    multiline
                    rows={3.5}
                    value={Assetdata.Content}
                    error={Assetdata.ContentStatus === "error"}
                    success={Assetdata.ContentStatus === "success"}
                    onChange={handleAsstet}
                    sx={{
                      width: "100%",
                      backgroundColor: "#FFF",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                </Box>

                <DialogActions sx={{ justifyContent: "center" }}>
                  <MaterialButton
                    onClick={() => setOpen(false)}
                    variant="gradient"
                    color="dark"
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    disabled={!checkAllAssertFields()}
                    variant="gradient"
                    color="dark"
                    onClick={handleassertmail}
                  >
                    Submit
                  </MaterialButton>
                </DialogActions>
              </>
            )}
          </DialogContent>
        </Dialog>
      </MaterialBox>
    </DashboardLayout>
  );
};
export default RecrruitmentTable;
